module.exports = __webpack_public_path__ + "37c76833162fcf1f1b8c3e2ad5aa4ec5.jpg";